// 导入完整的polyfills支持
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// 导入兼容性polyfills
import './lib/polyfills.js';

export const handleError = ({ error, event }) => {
  console.error('An error occurred:', error);
};